module.exports = __webpack_public_path__ + "img/backyard-alt-wide.bfc8a645.webp";